import config from 'config/Config';
import BaseApi from './BaseApi';
import type { LearningTeamSummary } from 'types/store/normalized';
import type { JsonApiResponse } from 'types/store/jsonApi';

interface LearningTeamAttributes {
  name: string;
}

type LearningTeamByIdResponse = JsonApiResponse<LearningTeamAttributes>;

export default class LearningTeamsApi extends BaseApi<LearningTeamSummary> {
  constructor() {
    super(`${config.get('backendURL')}learning-teams/`, 'cognota-be');
  }

  async setManagers(teamId: string, managerIds: string[]): Promise<void> {
    await this.axiosInstance.patch(`${teamId}/relationships/managers`, {
      data: managerIds.map((id) => ({ type: 'users', id })),
    });
  }

  async getEligibleParents(teamId: string): Promise<LearningTeamSummary[]> {
    const { data } = await this.axiosInstance.get<LearningTeamByIdResponse>(
      `${teamId}?include=eligible-parents-for-team`
    );

    const resource = Array.isArray(data.data) ? data.data[0] : data.data;
    const relationshipData =
      resource?.relationships?.['eligible-parents-for-team']?.data;
    const eligibleIds = new Set(
      Array.isArray(relationshipData) ? relationshipData.map((r) => r.id) : []
    );

    return (data.included ?? [])
      .filter((r) => r.type === 'learning-teams' && eligibleIds.has(r.id))
      .map((r) => ({ id: r.id, name: r.attributes.name ?? '' }));
  }
}
